/* Mara article page (F22): reading progress, "On this page" list, FAQ accordion, mobile buy bar. */
(function () {
  var root = document.querySelector('.ma');
  if (!root) return;
  var body = root.querySelector('.ma-body');
  if (!body) return;

  // Tidy older posts (written in the old editor) so they read like the new ones:
  // real section headings, clean paragraphs, no leftover editor styling. Text is never changed.
  function normalize(body) {
    var KEEP = function (el) {
      return el.nodeType === 1 && (el.classList.contains('ma-card') || el.classList.contains('ma-pq') || el.classList.contains('mara-product-card') || el.classList.contains('tbl'));
    };
    var doc = body.ownerDocument;
    var INLINE = /^(A|B|STRONG|EM|I|U|SPAN|SMALL|SUB|SUP|CODE|MARK|S|FONT|ABBR|CITE|Q|IMG|BR)$/;
    var textOf = function (el) { return (el.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim(); };

    // 1. Drop editor leftovers: meta tags, inline styles, empty spans.
    body.querySelectorAll('meta,script,style').forEach(function (n) { if (!n.closest('.mara-product-card')) n.remove(); });
    body.querySelectorAll('[style]').forEach(function (n) { if (!n.closest('.mara-product-card') && n.tagName !== 'IMG') n.removeAttribute('style'); });
    body.querySelectorAll('font').forEach(function (n) { n.replaceWith.apply(n, Array.prototype.slice.call(n.childNodes)); });

    // 2. Unwrap layout divs at the top level.
    var changed = true;
    while (changed) {
      changed = false;
      Array.prototype.slice.call(body.children).forEach(function (el) {
        if (el.tagName === 'DIV' && !KEEP(el)) {
          el.replaceWith.apply(el, Array.prototype.slice.call(el.childNodes));
          changed = true;
        }
      });
    }

    // 3. Wrap loose text and inline runs in paragraphs.
    var run = null;
    Array.prototype.slice.call(body.childNodes).forEach(function (n) {
      var inline = n.nodeType === 3 || (n.nodeType === 1 && INLINE.test(n.tagName));
      if (inline) {
        if (n.nodeType === 3 && !run && !n.textContent.trim()) return;
        if (!run) { run = doc.createElement('p'); n.before(run); }
        run.appendChild(n);
      } else {
        run = null;
      }
    });

    // 4. Split paragraphs on blank lines (two or more line breaks).
    Array.prototype.slice.call(body.querySelectorAll(':scope > p')).forEach(function (p) {
      var html = p.innerHTML;
      var pieces = html.split(/(?:\s|&nbsp;)*(?:<br\s*\/?>(?:\s|&nbsp;)*){2,}/i);
      if (pieces.length < 2) return;
      pieces.forEach(function (piece) {
        if (!piece.replace(/&nbsp;|<[^>]+>|\s/g, '')) return;
        var np = doc.createElement('p');
        np.innerHTML = piece;
        p.before(np);
      });
      p.remove();
    });

    // 6. Heading levels: h1 in the text becomes h2; with no h2, the top level in use becomes h2.
    var rename = function (el, tag) {
      var n = doc.createElement(tag);
      n.innerHTML = el.innerHTML;
      if (el.id) n.id = el.id;
      el.replaceWith(n);
    };
    body.querySelectorAll(':scope > h1').forEach(function (h) { rename(h, 'h2'); });
    if (body.querySelectorAll(':scope > h2').length < 2 && body.querySelectorAll(':scope > h3').length >= 2) {
      body.querySelectorAll(':scope > h3').forEach(function (h) { rename(h, 'h2'); });
      body.querySelectorAll(':scope > h4').forEach(function (h) { rename(h, 'h3'); });
    } else if (!body.querySelector(':scope > h2')) {
      if (body.querySelector(':scope > h3')) {
        body.querySelectorAll(':scope > h3').forEach(function (h) { rename(h, 'h2'); });
        body.querySelectorAll(':scope > h4').forEach(function (h) { rename(h, 'h3'); });
      } else {
        body.querySelectorAll(':scope > h4').forEach(function (h) { rename(h, 'h2'); });
      }
    } else {
      body.querySelectorAll(':scope > h4').forEach(function (h) { rename(h, 'h3'); });
    }
    // 5. A bold-only paragraph is a heading. So is a bold lead line followed by a line break.
    var isHeadingText = function (t) {
      return t.length > 1 && t.length <= 110 && !/[.!]["'”’)]*$/.test(t);
    };
    var cleanHeading = function (t) { return t.replace(/\s*:\s*$/, ''); };
    if (body.querySelectorAll(':scope > h2').length < 2) Array.prototype.slice.call(body.querySelectorAll(':scope > p')).forEach(function (p) {
      var kids = Array.prototype.slice.call(p.childNodes).filter(function (n) {
        return !(n.nodeType === 3 && !n.textContent.replace(/\u00a0/g, '').trim()) && !(n.nodeType === 1 && n.tagName === 'BR');
      });
      var t = textOf(p);
      if (kids.length === 1 && kids[0].nodeType === 1 && /^(STRONG|B)$/.test(kids[0].tagName) && !kids[0].querySelector('img') && isHeadingText(t)) {
        var h = doc.createElement('h2');
        h.textContent = cleanHeading(t);
        p.replaceWith(h);
        return;
      }
      if (t.length <= 80 && /:$/.test(t) && kids.length === 1 && kids[0].nodeType === 1 && !p.querySelector('img,a')) {
        var hc = doc.createElement('h2');
        hc.textContent = cleanHeading(t);
        p.replaceWith(hc);
        return;
      }
      var first = kids[0];
      if (first && first.nodeType === 1 && /^(STRONG|B)$/.test(first.tagName) && kids.length > 1) {
        var leadText = textOf(first);
        var nx = first.nextSibling;
        while (nx && nx.nodeType === 3 && !nx.textContent.trim()) nx = nx.nextSibling;
        var isBr = nx && nx.nodeType === 1 && nx.tagName === 'BR';
        if (!isBr && /:$/.test(leadText) && leadText.length <= 80 && !first.querySelector('img,a')) {
          var hr = doc.createElement('h2');
          hr.textContent = cleanHeading(leadText);
          p.before(hr);
          first.remove();
          if (p.firstChild && p.firstChild.nodeType === 3) p.firstChild.textContent = p.firstChild.textContent.replace(/^[\s\u00a0]+/, '');
          return;
        }
      }
      if (first && first.nodeType === 1 && /^(STRONG|B)$/.test(first.tagName)) {
        var after = first.nextSibling;
        while (after && after.nodeType === 3 && !after.textContent.trim()) after = after.nextSibling;
        var lead = textOf(first);
        if (after && after.nodeType === 1 && after.tagName === 'BR' && isHeadingText(lead)) {
          var h2 = doc.createElement('h2');
          h2.textContent = cleanHeading(lead);
          p.before(h2);
          first.remove();
          after.remove();
          while (p.firstChild && ((p.firstChild.nodeType === 3 && !p.firstChild.textContent.trim()) || p.firstChild.tagName === 'BR')) p.firstChild.remove();
        }
      }
    });

    body.querySelectorAll(':scope > h2, :scope > h3').forEach(function (h) {
      var t = textOf(h);
      if (!t) { h.remove(); return; }
      if (/:$/.test(t)) h.textContent = cleanHeading(t);
    });

    // 7. Remove empty paragraphs and trailing line breaks.
    body.querySelectorAll(':scope > p').forEach(function (p) {
      while (p.lastChild && ((p.lastChild.nodeType === 3 && !p.lastChild.textContent.replace(/\u00a0/g, '').trim()) || p.lastChild.tagName === 'BR')) p.lastChild.remove();
      while (p.firstChild && ((p.firstChild.nodeType === 3 && !p.firstChild.textContent.replace(/\u00a0/g, '').trim()) || p.firstChild.tagName === 'BR')) p.firstChild.remove();
      if (!textOf(p) && !p.querySelector('img,iframe,video')) p.remove();
    });

    // Posts whose headings are already numbered ("1. Pure energy") keep their own numbers.
    var numbered = Array.prototype.filter.call(body.querySelectorAll(':scope > h2'), function (h) { return /^\s*\d+[.)]\s/.test(h.textContent); });
    if (numbered.length >= 2) body.classList.add('ma-numbered');

    // 8. The theme puts the product card at the end of posts it couldn't split; move it after the first section.
    var card = body.querySelector(':scope > .ma-card');
    var hs = body.querySelectorAll(':scope > h2');
    if (card && hs.length >= 2 && card === body.lastElementChild) hs[1].before(card);
  }
  normalize(body);


  // FAQ: turn a "Questions ..." h2 and the h3 + answer pairs under it into an accordion.
  var heads = Array.prototype.slice.call(body.querySelectorAll(':scope > h2'));
  heads.forEach(function (h2) {
    if (!/^\s*questions/i.test(h2.textContent)) return;
    var wrap = document.createElement('div');
    wrap.className = 'ma-faq';
    var node = h2.nextElementSibling;
    var current = null;
    while (node && node.tagName !== 'H2') {
      var next = node.nextElementSibling;
      if (node.tagName === 'H3') {
        current = document.createElement('details');
        var s = document.createElement('summary');
        s.innerHTML = node.innerHTML;
        current.appendChild(s);
        var ans = document.createElement('div');
        ans.className = 'ans';
        current.appendChild(ans);
        wrap.appendChild(current);
        node.remove();
      } else if (current && !node.classList.contains('ma-card') && !node.classList.contains('mara-product-card')) {
        current.querySelector('.ans').appendChild(node);
      }
      node = next;
    }
    if (wrap.children.length) {
      h2.after(wrap);
      wrap.querySelector('details').open = true;
    }
  });

  // On this page
  heads = Array.prototype.slice.call(body.querySelectorAll(':scope > h2'));
  var lists = root.querySelectorAll('[data-toc]');
  var links = [];
  if (heads.length >= 3) {
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
    });
    lists.forEach(function (ol) {
      heads.forEach(function (h, i) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        var n = document.createElement('span');
        n.textContent = (i < 9 ? '0' : '') + (i + 1);
        a.appendChild(n);
        a.appendChild(document.createTextNode(body.classList.contains('ma-numbered') ? h.textContent.trim().replace(/^\d+[.)]\s+/, '') : h.textContent.trim()));
        a.addEventListener('click', function () {
          var d = a.closest('details');
          if (d) d.open = false;
        });
        li.appendChild(a);
        ol.appendChild(li);
        if (ol.closest('.ma-toc')) links.push(a);
      });
      ol.closest('[hidden]') && ol.closest('[hidden]').removeAttribute('hidden');
    });
  }

  // Progress, active section and buy bar
  var bar = root.querySelector('.ma-progress span');
  var buy = root.querySelector('.ma-bar');
  var hero = root.querySelector('.ma-hero');
  var close = root.querySelector('.ma-close');
  var ticking = false;
  function update() {
    ticking = false;
    var r = body.getBoundingClientRect();
    var total = body.offsetHeight - window.innerHeight * 0.6;
    var done = Math.min(1, Math.max(0, -r.top / (total > 0 ? total : 1)));
    if (bar) bar.style.width = (done * 100).toFixed(1) + '%';
    if (links.length) {
      var active = 0;
      heads.forEach(function (h, i) {
        if (h.getBoundingClientRect().top < 140) active = i;
      });
      links.forEach(function (a, i) {
        a.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    }
    if (buy && hero) {
      var past = hero.getBoundingClientRect().bottom < 0;
      var atClose = close && close.getBoundingClientRect().top < window.innerHeight;
      buy.classList.toggle('show', past && !atClose);
    }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
